<template>
      <div class="gradeCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'grade', params: {} }">
          Grade
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'gradeCreate', params: {} }">
            Add Grade
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Add Grade</v-card-title>
          <v-card-text>
            <grade-form></grade-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import GradeForm from './GradeForm.vue';

    export default {
      name: 'grade',
      components: {
        GradeForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    